/* Galería de producto estilo Vita Labs - flechas en miniaturas (sin lupa de zoom) */
(function () {
  function centrarMiniatura(controles, miniatura) {
    var caja = controles.querySelector('.slideshow-controls__thumbnails-container');
    if (!caja || !miniatura) return;
    var r = miniatura.getBoundingClientRect();
    var c = caja.getBoundingClientRect();
    caja.scrollBy({ left: r.left - c.left - (c.width - r.width) / 2, behavior: 'smooth' });
  }

  function mejorar() {
    document.querySelectorAll('media-gallery.media-gallery--carousel').forEach(function (galeria) {
      galeria.querySelectorAll('slideshow-controls[thumbnails]').forEach(function (controles) {
        if (controles.querySelector('.gv-arrow')) return;
        ['prev', 'next'].forEach(function (dir) {
          var flecha = document.createElement('button');
          flecha.type = 'button';
          flecha.className = 'gv-arrow gv-arrow--' + dir;
          flecha.setAttribute('aria-label', dir === 'prev' ? 'Imagen anterior' : 'Imagen siguiente');
          flecha.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
          flecha.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var minis = Array.prototype.slice.call(controles.querySelectorAll('.slideshow-controls__thumbnail'));
            if (!minis.length) return;
            var actual = minis.findIndex(function (m) { return m.getAttribute('aria-selected') === 'true'; });
            if (actual < 0) actual = 0;
            var nuevo = dir === 'prev' ? (actual - 1 + minis.length) % minis.length : (actual + 1) % minis.length;
            minis[nuevo].click();
            centrarMiniatura(controles, minis[nuevo]);
          });
          controles.appendChild(flecha);
        });
      });
    });
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; mejorar(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mejorar);
  } else {
    mejorar();
  }
  new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
})();
